import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'
import { Trash } from 'react-feather'

export const CustomTextArea = styled(TextFieldMui)`
    margin: 0 !important;
    width: 58rem !important;
    height: 8.3rem !important;

    & input {
        height: 1.5rem !important;
    }
`

export const CustomButtonSku = styled(ButtonMui)`
    width: 16rem !important;    
    height: 3rem !important;
    margin: 0 !important;
    margin-top: 0.2rem !important;
    margin-bottom: 0.2rem !important;
`

export const RemoveBatchButton = styled(Trash)`
    cursor: pointer;
    color: red;
`

export const InvalidSku = styled.p`
    color: red;
`

export const ContainerButton = styled.div`
    display: flex;
    justify-content: center;
    gap: 1rem;
    align-items: center;
    width: 100%;
`
